import React, {useEffect, useState} from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faList, faArrowDown, faSpinner} from "@fortawesome/free-solid-svg-icons";
import { getLatestAnswers } from '../../functions/api';
import ReactGA from 'react-ga';

function LatestAnswers() {
    const [answers, setAnswers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);

ReactGA.initialize('UA-35615300-1');
ReactGA.pageview(window.location.pathname + window.location.search);

    useEffect(()=>{
        setLoading(true)
        getLatestAnswers(setAnswers, page, setLoading)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[page])

    const showMore = () => {
        setPage(page+1);
    }

    let list = [];

    answers.map((item,index)=>{
        const {articles_by_author_url, author_name, url: article_url, author_sex, author_photo, title, categories} = item || '';
        const {url, name} = categories[0] || '';
        list.push(
            <article key={index} className="article">
                <div className="article-author">
                    <div className="author-avatar">
                        <a href={articles_by_author_url}>
                                <img className="article-author-photo"width="50" height="50" alt={author_name} title={author_name} src={author_photo}/>
                            </a>
                    </div>
                    <div>
                        <div className="article-header">
                                <div className="tip">
                                    <h2>
                                        <a  href={article_url}>{title}</a>
                                    </h2>
                                </div>
                                <div className="author">
                                    Napisał{author_sex==="F"?'a':''}&nbsp;
                                    <a className="author" href={articles_by_author_url}>
                                        {author_name}&nbsp;
                                    </a>
                                </div>
                                <div className="article-categories">{categories.length>0?'z dziedziny':''}
                                        <a className="no-decorate"href={url}>&nbsp;{name}</a>
                                </div>
                            </div>
                    </div>
                </div>
            </article>
        )
        return list
    })

    return (
    <>
    <section className="articles">
        <div className="container">
            <h1 className="mainHeader text-center">Najnowsze porady prawników</h1>
                {list}
        </div>
        <div className="text-center pf-actions">
                <a href="/poradnik-prawny/">
                    <div className="loading-btn pointer">
                        <FontAwesomeIcon icon={faList} className="icon"/>
                        <div className="loading-btn-text">Zobacz wszystkie</div>
                    </div>
                </a>

                <div className="loading-btn">
                    <FontAwesomeIcon icon={loading?faSpinner:faArrowDown} className="icon" onClick={showMore}/>
                    <div className="loading-btn-text">{loading? 'Przetwarzanie': 'Pokaż więcej'}</div>
                </div>
            </div>
    </section>
    </>
  )
}

export default LatestAnswers